var render = function render(){var _vm=this,_c=_vm._self._c;return _c('strong',[_c('a',{staticClass:"link-tag",attrs:{"text":"","href":_vm.telephoneRef},on:{"click":_vm.onPhoneNumber}},[_vm._v(_vm._s(_vm.phone))])])
}
var staticRenderFns = []

export { render, staticRenderFns }